module.exports = __webpack_public_path__ + "media/images/static/top/urban/center_photo_bg-f8d93d34f6fa31818e32ea8ec3fb28f2.png";